<template class="modal-no-leftovers">
<b-modal id="no-leftovers-modal" centered :hide-footer="true" :hide-header="true" @hidden="$emit('dismissModal', $event)">
  <template v-slot:default="{ hide }">
    <p class="modal-title">{{ $t('recipes.lblNoLeftoversAvailable') }}</p>
  </template>

  <div class="modal-text">
    <p>{{ $t('recipes.lblNoLeftoversDescription1') }}</p>
    <p>{{ $t('recipes.lblNoLeftoversDescription2') }}</p>
  </div>

  <template v-slot:modal-footer="{ hide }">
    <BaseButton class="btn-clear" @click="hide()">
      {{ $t('lblBack') }}
    </BaseButton>
  </template>
</b-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {
    hide() {
      this.$bvModal.hide('no-leftovers-modal');
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-title {
  font-size: 1.7rem;
  font-weight: 600 !important;
  margin-bottom: 2.4rem;
}

.modal-body {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.modal-text {
  font-weight: 400;
  text-align: left;
}

.modal-action-wrapper {
  margin-bottom: 2rem;
}

.button.btn-clear.btn-clear {
  border-radius: $base-border-radius;
  color: $color-action !important;
  font-size: 1.7rem;
  font-weight: 400;
  margin-top: 3rem;
  text-transform: capitalize !important;
}
</style>
